import Vue from 'vue'
import Vuex from 'vuex'
import userModule from '@/modules/user/store'
import adminModule from '@/modules/admin/store'
import profesorModule from '@/modules/profesor/store'
Vue.use(Vuex)
export default new Vuex.Store({
  modules :{
    user: userModule,
    admin: adminModule,
    profesor: profesorModule
  },
  state()
  {
    return{
      showAlert: false,
      dataAlert:{}
    }
  },
  getters: {
    getShowAlert(state) {
      return state.showAlert
    },
    getDataAlert(state) {
      return state.dataAlert
    }
  },
  mutations: {
    setAlert(state, payload) {
      state.showAlert = payload
    },
    setDataAlert(state, payload) {
      state.dataAlert = payload
    }
  },
})
